import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import ReloadIcon from '@material-ui/icons/Replay';
import Chip from '@material-ui/core/Chip';
import * as validator from "validator";
import { CsvBuilder } from 'filefy';
import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});

const defaults = {
    id: true,
    name: false,
    building: false,
    reference: false,
    pageSize: 20,
};

const defaultsPropertyName = 'p71.parcels.defaults';

class Parcels extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            exporting: false,
            progressValue: 0,
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    getInput = (data) => {

        try {

            if (
                validator.isEmpty(`${data.building}`)
            ) {
                throw new Error(i18n.get("parcels.error.validation"));
            }

            const input = {}

            helper.set(input, data, "building", (b => Array.isArray(b) ? b[0]["value"] : b["id"]));
            helper.set(input, data, "name");
            helper.set(input, data, "reference");

            if (!input["name"]) input["name"] = null
            if (!input["reference"]) input["reference"] = null

            return input;

        } catch (error) {
            throw new Error(i18n.get("parcels.error.validation"))
        }
    }

    mapField(column) {
        return column;
    }

    getBuildingSuggestions = async (value) => {
        try {
            const where = `[{column: "street", comparator: LIKE, string: "${value}"}]`;

            const result = await graphql.clientWithToken(this.props.accessToken).query({
                query: gql`
                query {
                    buildings(first: 5, offset: 0, where:${where} orderBy: [{column: "id", direction: ASC}]) {
                        totalCount
                        elements {
                            ... on Building {
                                street
                                id
                           }
                        }
                    }
                }
            `,
                fetchPolicy: 'no-cache',
            });

            return result.data.buildings.elements.map((element) => {
                return {
                    name: helper.buildingChipOf(element.street, element.id),
                    value: element.id,
                };
            });
        } catch (error) {
            console.log(error.message);
            return [];
        }
    };

    getDefaultSuggestions = () => {
        return [];
    }

    hasChildren = async (id) => {
        try {

            const result = await graphql.clientWithToken(this.props.accessToken).query({
                variables: {
                    "id": id,
                },
                query: gql`
                query parcel($id: ID!) { 
                    parcel (id: $id) {
                        taps {
                            id
                        }
                }
            }
            `,
                fetchPolicy: "no-cache"
            });

            return result.data.parcel.taps.length > 0;

        } catch (error) {
            console.log(error.message);
            return false
        }
    }

    exportCsv = async (columns, data) => {

        try {

            this.setState({
                exporting: true,
                progressValue: 0
            });

            const allParcels = [];
            let totalCount = 0;
            const first = 100;
            let offset = 0

            this.showMessage("Export wird angestoßen. Bitte verlassen Sie die Seite nicht, solange der Exportvorgang läuft.", "info");

            do {
                
                const filters = []
                for (const column of columns) {
                    if (column.tableData.filterValue !== undefined && column.tableData.filterValue !== null) {
                        filters.push({
                            column: column,
                            field: column.field,
                            type: column.type,
                            comparator: column.comparator,
                            value: column.tableData.filterValue
                        })
                    }
                }

                const find = helper.whereString(filters, this.mapField, ["id"]);

                const result = await graphql.clientWithToken(this.props.accessToken).query({
                    query: gql`
                    query {
                        parcels(first: 100, offset: ${offset}, where: ${find}, orderBy: [{column: "id" direction: ASC}]) {
                            totalCount
                            elements {
                                ... on Parcel {
                                    id
                                    name
                                    reference
                                    building { street }
                                }
                            }
                        }
                    }
                `,
                    fetchPolicy: "no-cache"
                });

                totalCount = result.data.parcels.totalCount;
                offset = offset + first;
                for (const parcel of result.data.parcels.elements) {
                    allParcels.push(
                        {
                            id: parcel.id,
                            street: parcel.building ? parcel.building.street : '-',
                            name: parcel.name,
                            reference: parcel.reference,
                        }
                    )
                }

                if (totalCount !== 0) {
                    this.setState({
                        exporting: true,
                        progressValue: (allParcels.length / totalCount) * 100
                    });
                }
            } while (allParcels.length < totalCount);

            const builder = new CsvBuilder('Wohnungen.csv')
                .setDelimeter(";")
                .setColumns(columns.map(columnDef => columnDef.title))
                .addRows(allParcels.map(parcel => { return [parcel.name, parcel.reference, parcel.street, parcel.id] }))
                .exportFile();

            this.setState({
                exporting: false,
                progressValue: 0
            });
        } catch (error) {
            this.setState({
                exporting: false,
                progressValue: 0
            });
            this.showMessage(error.message, "error");
        }

    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>

                {this.state.exporting && <div style={{ width: "100%" }}><LinearProgress value={this.state.progressValue} variant={"determinate"} /></div>}

                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("parcels.name"),
                            field: 'name',
                            hidden: this.default("name"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            sorting: true,
                            filtering: true,
                            editComponent: helper.required
                        },
                        {
                            title: i18n.get("parcels.reference"),
                            field: 'reference',
                            hidden: this.default("reference"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("parcels.building"),
                            width: '600px',
                            maxWidth: '600px',
                            hidden: this.default("building"),
                            cellStyle: {
                                minWidth: '500px',
                                maxWidth: '500px',
                            },
                            headerStyle: {
                                minWidth: '500px',
                                maxWidth: '500px',
                            },
                            field: "building",
                            sorting: true,
                            filtering: true,
                            comparator: 'IS',
                            render: rowData => { return rowData.building && rowData.building.street ? <Chip label={`${rowData.building.street}`} /> : null },
                            filterComponent: helper.chipsFilter(
                                (items, props) =>
                                    props.onFilterChanged(
                                        props.columnDef.tableData.id,
                                        items.map((item) => `${item.value}`)
                                    ),
                                (value) =>
                                    value.map((v) => {
                                        return {
                                            name: `${v.label} (${v.id})`,
                                            value: v.id,
                                        };
                                    }),
                                this.getBuildingSuggestions,
                                this.getDefaultSuggestions
                            ),
                            editComponent: (props) => {
                                return helper.chips(
                                    props,
                                    props.value ? [{ name: `${props.value.street}`, value: props.value.id }] : [],
                                    i18n.get("parcels.building"),
                                    null,
                                    this.getBuildingSuggestions,
                                    this.getDefaultSuggestions,
                                )
                            },
                        },
                        {
                            title: i18n.get("parcels.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.id) || null,
                            sorting: true,
                            filtering: true,
                            editable: 'never',
                        },
                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {

                                const where = helper.whereString(query['filters'], this.mapField, ["id"]);
                                let orderBy = helper.orderByString(query, this.mapField, 'id', true);
                                if (where === "[]") {
                                    orderBy = helper.orderByString(query, this.mapField, "id")
                                }

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        parcels(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Parcel {
                                                    id
                                                    name
                                                    reference
                                                    building { id street }
                                                    taps { id name valve }
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.parcels.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                name: element.name,
                                                reference: element.reference,
                                                building: element.building,
                                                taps: element.taps,
                                            };
                                        }),
                                    totalCount: result.data.parcels.totalCount
                                }
                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }

                    detailPanel={
                        rowData => {
                            return (
                                <div>
                                    <Paper>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">{i18n.get("parcels.taps.id")}</TableCell>
                                                    <TableCell align="center">{i18n.get("parcels.taps.name")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rowData.taps.map(row => (
                                                    <TableRow key={row.id}>
                                                        <TableCell align="center" component="th" scope="row"> {row.id} </TableCell>
                                                        <TableCell align="center">{row.name}{row.name && row.valve ? ', ' : ''} {row.valve}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                </div>
                            );
                        }
                    }

                    actions={[{
                        isFreeAction: true,
                        icon: () => { return <ReloadIcon /> },
                        tooltip: i18n.get("general.reload"),
                        onClick: async (event, rowData) => {
                            this.tableRef.current.onQueryChange();
                        }
                    }]}
                    title={i18n.get("parcels.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: !this.state.exporting,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        exportCsv: this.exportCsv,
                        pageSize: this.default("pageSize"),
                        pageSizeOptions: [5, 20, 50]
                    }}

                    editable={{
                        isEditable: rowData => isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]),
                        isDeletable: rowData => isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]),
                        onRowAdd: isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]) ? newData =>
                            new Promise(async (resolve, reject) => {
                                try {

                                    const input = this.getInput(newData)

                                    const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                        variables: {
                                            "input": input,
                                        },
                                        mutation: gql`
                                        mutation addParcel($input: ParcelInput!) {
                                            addParcel(input: $input) {
                                                id
                                            }
                                        }
                                    `,
                                    });

                                    this.showMessage(i18n.get("parcels.message.onRowAdd.success"), "success")

                                    resolve();
                                } catch (error) {
                                    this.showMessage(i18n.get("parcels.message.onRowAdd.error"), "error", error.message);
                                    reject(error);
                                }
                            }) : null,
                        onRowUpdate: (newData, oldData) =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    const input = this.getInput(newData);

                                    const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                        variables: {
                                            "id": newData.id,
                                            "input": input,
                                        },
                                        mutation: gql`
                                        mutation updateParcel($id: ID!, $input: ParcelInput!) {
                                            updateParcel(id: $id, input: $input) {
                                                id
                                            }
                                        }
                                    `,
                                    });

                                    this.showMessage(i18n.get("parcels.message.onRowUpdate.success"), "success")

                                    resolve(result);
                                } catch (error) {

                                    this.showMessage(i18n.get("parcels.message.onRowUpdate.error"), "error", error.message)
                                    reject(error);
                                }
                            }),
                        onRowDelete: oldData =>
                            new Promise(async (resolve, reject) => {

                                try {
                                    const hasChildren = await this.hasChildren(oldData.id)

                                    if (!hasChildren) {
                                        const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                            variables: {
                                                "id": oldData.id,
                                            },
                                            mutation: gql`
                                            mutation deleteParcel($id: ID!) {
                                                deleteParcel(id: $id)
                                            }
                                        `,
                                        });

                                        this.showMessage(i18n.get("parcels.message.onRowDelete.success"), "success")

                                        resolve(result);

                                    } else {
                                        this.showMessage(i18n.get("parcels.message.onRowDelete.notEmpty"), "error")
                                        reject();
                                    }
                                } catch (error) {
                                    this.showMessage(i18n.get("parcels.message.onRowDelete.error"), "error", error.message)
                                    reject(error);
                                }
                            }),
                    }}

                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </div>
        )
    }
}

Parcels.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Parcels))